export enum EActionType {
  DeveloperMode = 'DeveloperMode',
  Duplicate = 'Duplicate',
  Download = 'Download',
  Restore = 'Restore',
  Rename = 'Rename',
  Delete = 'Delete',
  ToBin = 'ToBin'
}
